import gql from 'graphql-tag';
export default gql`
  mutation DeleteLinkById($input: DeleteLinkByIdInput!) {
    deleteLinkById(input: $input) {
      deletedLinkId
    }
  }
`;
